import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import ClickableDiv from 'components/ClickableDiv';
import FilterChevron from 'screens/Property/components/FilterChevron';
import { verticalCollapse } from 'utilities/animations';
import { nanoid as generate } from 'nanoid';
import { Switch } from 'syngenta-digital-cropwise-react-ui-kit';
import './index.css';

const selectArrowIcon = open => <FilterChevron open={open} />;

const CollapsibleToggle = ({ title, options, showOptions = false }) => {
  const [toggleOptions, setToggleOptions] = useState(showOptions);
  const [arrowIcon, setArrowIcon] = useState(selectArrowIcon(showOptions));

  const optionsRef = useRef();

  useEffect(() => {
    setArrowIcon(selectArrowIcon(toggleOptions));
    verticalCollapse(optionsRef.current, toggleOptions);
  }, [toggleOptions]);

  return (
    <div className="my-3">
      <ClickableDiv
        className="flex justify-between items-center mb-4 px-5"
        onClick={() => setToggleOptions(!toggleOptions)}
      >
        <span className="text-black font-semibold">{title}</span>
        {arrowIcon}
      </ClickableDiv>
      <div
        className="transition-all duration-200 overflow-y-hidden border-b border-neutral-100"
        ref={optionsRef}
        data-testid="collapsible-options"
      >
        <ul className="text-black px-5 pt-2 pb-4 gap-y-4">
          {options?.map(option => (
            <label
              key={generate()}
              className="flex flex-row items-center justify-between pb-2"
            >
              <span className="text-neutral-1000 font-light">
                {option.name}
              </span>
              <span className="collapsible-toggle-switch">
                <Switch checked={option.value} onChange={option.onChange} />
              </span>
            </label>
          ))}
        </ul>
      </div>
    </div>
  );
};

CollapsibleToggle.propTypes = {
  title: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      onChange: PropTypes.func,
      value: PropTypes.bool
    })
  ).isRequired,
  showOptions: PropTypes.bool
};

export default CollapsibleToggle;
